import { useAtom } from '@reatom/npm-react'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { FlashTextContentDistinct } from '@root/features/flash/flash-text-content-distinct'
import { CountMax3DigitsFormatted } from '@root/shared/core/format'
import { UserGroupIcon } from '@root/shared/ui-kit'

import { PairStatsPanelTopRowItem } from './pair-stats-panel-top-row-item'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const PairStatsPanelHolders: React.FC<Props> = memo(({ pair }) => {
  const { t } = useTranslation()
  const [holdersCount] = useAtom(pair.holdersCount)

  return (
    <PairStatsPanelTopRowItem
      title={t('common.holders')}
      intent="Neutral"
      icon={UserGroupIcon}
      tooltip={t('trading.audit.holders_tooltip')}
      value={
        <FlashTextContentDistinct>
          <CountMax3DigitsFormatted count={holdersCount} />
        </FlashTextContentDistinct>
      }
    />
  )
})
